// tslint:disable

import axios from 'axios';
import { get } from 'lodash';
import * as React from 'react';
import { Environment } from '../../../environment/environment';
import './iri-presenter.scss';

export interface MediaItemPresenterProps {
    className?: any;
    iri: any;
    width: any;
    size?: string;
}

export class MediaItemPresenter extends React.Component<MediaItemPresenterProps, any> {
    public state: any = {
        iriValue: null,
        hasError: false,
        isLoading: false
    };

    async componentDidMount() {
        this.fetchIri(this.props.iri);
    }

    async componentDidUpdate(prevProps: any, prevState: any) {
        if (prevProps.iri !== this.props.iri) {
            this.fetchIri(this.props.iri);
        }
    }

    public async fetchIri(iri: string) {
        this.setState({
            isLoading: true,
            hasError: false
        });

        try {
            if (!iri) {
                this.setState({
                    iriValue: null,
                    hasError: false,
                    isLoading: false
                });

                return;
            }

            const response = await axios.get(`${Environment.get('api.base')}${this.toIri(iri)}`, {withCredentials: true});

            if (!response.data) {
                this.setState({
                    hasError: true,
                    isLoading: false
                });
            }

            this.setState({
                iriValue: response.data,
                hasError: false,
                isLoading: false
            });
        } catch (err) {
            this.setState({
                hasError: true,
                isLoading: false
            });
        }
    }

    render() {
        return (
            <div ref={'IRI'} className="iri-pointer">
                {this.state.isLoading && <i className="fa fa-spin fa-circle-o-notch"/>}
                {(!this.state.isLoading && !this.state.hasError) && (<img src={get(this.state.iriValue, `images[${this.props.size ? `"${this.props.size}"` : "original" }]`)} className={this.props.className || ''} style={{width: this.props.width}}/> || <span>-</span>)}
                {(!this.state.isLoading && this.state.hasError) && <div className="text-danger">Error</div>}
            </div>
        );
    }

    private toIri(raw: any) {
        if (get(raw, '@id')) {
            return get(raw, '@id');
        } else {
            return raw;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/structurals/presenters/media-item-presenter.tsx